import ResourceUtilities from './ResourceUtilities';

export default ResourceUtilities;
